/**
 * Import the reducers from features and pass to combineReducers
*/

import { combineReducers } from 'redux';
import SideBar from 'features/side-bar/SideBar.reducer';
import Authorize from 'features/authorize/Authorize.reducer';
import ViewProfileDialog from 'features/view-profile-dialog/ViewProfileDialog.reducer';
import Notifications from 'features/NotificationsPopup/Notifications.reducer';
import UserEntitledApps from 'features/user-entitled-apps/UserEntitledApps.reducer';
import { GuestAccessReducer } from 'features/guest-access';

const rootReducer = combineReducers({
  SideBar,
  Authorize,
  ViewProfileDialog,
  Notifications,
  UserEntitledApps,
  GuestAccess: GuestAccessReducer,
});

export default rootReducer;
